/* Keep RosaVeluxe gel 1+1 packs together when cart quantities change. */
(() => {
  'use strict';
  const deals = new Set(['6sfx', 'a9Ll', 'Vytv']);
  const gel = 8430528364610;
  const gifts = new Set([8428618219586, 8428618285122, 8428618252354, 8445520314434]);
  let busy = false;

  function metadata(value) {
    try {
      const data = JSON.parse(value || '{}');
      return deals.has(data.deal) && data.id ? data : null;
    } catch (_) { return null; }
  }

  function updatesForPack(cart, pack, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('invalid_quantity');
    const lines = cart.items.filter(item => {
      const data = metadata(item.properties?.__kaching_bundles);
      return data && data.id === pack.id && data.deal === pack.deal;
    });
    const pens = lines.filter(item => item.product_id === gel);
    const extras = lines.filter(item => gifts.has(item.product_id));
    // Do not guess the composition of a different or incomplete offer.
    if (pens.length !== 2 || extras.length !== 4 || lines.length !== 6 ||
        new Set(extras.map(item => item.product_id)).size !== 4) throw new Error('incomplete_pack');
    return Object.fromEntries(lines.map(item => [item.key, quantity]));
  }

  function decorate() {
    document.querySelectorAll('[data-rv-gel-pack]').forEach(row => {
      if (row.classList.contains('rv-pack-ready') || !metadata(row.dataset.rvGelPack)) return;
      const free = row.dataset.rvFree === 'true';
      const wrapper = row.querySelector('.cart-item__quantity');
      if (!wrapper) return;
      const note = document.createElement('p');
      note.className = 'rv-pack-quantity-note';
      note.textContent = free ? 'Incluido · Cantidad: ' + row.dataset.quantity : 'Cantidad de packs';
      wrapper.prepend(note);
      row.querySelectorAll('input[name="updates[]"]').forEach(input => {
        if (!free) input.setAttribute('aria-label', 'Cantidad de packs 1+1 GRATIS');
      });
      row.querySelectorAll('cart-remove-button button, cart-remove-button a').forEach(button => {
        button.setAttribute('aria-label', 'Eliminar el pack completo');
      });
      row.classList.add('rv-pack-ready');
    });
  }

  function errorMessage() {
    const host = document.querySelector('cart-drawer.active #CartDrawer-CartErrors') ||
      document.querySelector('#cart-errors') || document.querySelector('#CartDrawer-CartErrors');
    if (host) host.textContent = 'No se ha podido actualizar el pack. Recarga el carrito y vuelve a intentarlo.';
  }

  async function changePack(row, quantity) {
    if (busy) return;
    const pack = metadata(row.dataset.rvGelPack);
    if (!pack) return;
    busy = true;
    const controls = [...document.querySelectorAll('cart-drawer button, cart-drawer input, cart-items button, cart-items input, #checkout')];
    const enabled = controls.filter(control => !control.disabled);
    enabled.forEach(control => { control.disabled = true; });
    row.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const beforeResponse = await fetch(root + 'cart.js', {cache: 'no-store'});
      if (!beforeResponse.ok) throw new Error('cart_read');
      const before = await beforeResponse.json();
      const updates = updatesForPack(before, pack, quantity);
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname})
      });
      if (!response.ok) throw new Error('cart_update');
      const cart = await response.json();
      if (cart.status) throw new Error('cart_update');
      if (document.querySelector('main cart-items')) {
        window.location.reload();
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !cart.sections?.['cart-drawer']) {
        window.location.assign(root + 'cart');
        return;
      }
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      drawer.renderContents(cart);
      decorate();
    } catch (_) {
      const input = row.querySelector('input[name="updates[]"]');
      if (input) input.value = row.dataset.quantity;
      errorMessage();
    } finally {
      busy = false;
      enabled.forEach(control => { if (control.isConnected) control.disabled = false; });
      row.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (busy && event.target.closest('cart-drawer a, cart-items a, [name="checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const row = event.target.closest('[data-rv-gel-pack]');
    if (!row || !metadata(row.dataset.rvGelPack)) return;
    const button = event.target.closest('button[name="plus"], button[name="minus"], cart-remove-button');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const remove = button.matches('cart-remove-button');
    const quantity = remove ? 0 : Number(row.dataset.quantity) + (button.getAttribute('name') === 'plus' ? 1 : -1);
    if (quantity >= 0) changePack(row, quantity);
  }, true);

  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'updates[]') return;
    const row = event.target.closest('[data-rv-gel-pack]');
    if (!row || !metadata(row.dataset.rvGelPack)) return;
    event.stopImmediatePropagation();
    const quantity = Number(event.target.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      event.target.value = row.dataset.quantity;
      return;
    }
    changePack(row, quantity);
  }, true);

  function init() {
    decorate();
    document.querySelectorAll('cart-drawer, main cart-items').forEach(cart => {
      new MutationObserver(decorate).observe(cart, {childList: true, subtree: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();

  // History navigation can restore HTML from before the last add-to-cart.
  // Reload once; the subsequent navigation type is "reload", so this cannot loop.
  window.addEventListener('pageshow', event => {
    const historyReturn = event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (historyReturn && document.querySelector('cart-drawer, cart-items')) window.location.reload();
  });
})();
